<template>
    <b-modal v-model="modal_toxicity.show"
             centered
             :title="component.name"
    >
        <form @submit.prevent="validateForm()"
              data-vv-scope="component"
        >
            <b-row>
                <b-col md="6">
                    <b-form-group>
                        <label for="cseo_fish">CSEO PECES <span class="text-black-50 small">(mg/l)</span></label>
                        <el-input id="cseo_fish"
                                  name="cseo_fish"
                                  size="small"
                                  type="text"
                                  v-model="component.toxicity.cseo_fish"
                                  data-vv-as=" "
                                  v-validate="'decimal:7|min_value:0|max_value:100000'"
                        />
                        <span class="text-danger small"
                              v-text="errors.first('component.cseo_fish')"
                        />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group>
                        <label for="cseo_crustaceans">CE50 CRUSTÁCEOS <span class="text-black-50 small">(mg/l)</span></label>
                        <el-input id="cseo_crustaceans"
                                  name="cseo_crustaceans"
                                  size="small"
                                  type="text"
                                  v-model="component.toxicity.cseo_crustaceans"
                                  data-vv-as=" "
                                  v-validate="'decimal:7|min_value:0|max_value:100000'"
                        />
                        <span class="text-danger small"
                              v-text="errors.first('component.cseo_crustaceans')"
                        />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <label for="cseo_algae">CSEO ALGAS <span class="text-black-50 small">(mg/l)</span></label>
                        <b-row>
                            <b-col>
                                <el-input id="cseo_algae"
                                          name="cseo_algae"
                                          size="small"
                                          type="text"
                                          v-model="component.toxicity.cseo_algae"
                                          data-vv-as=" "
                                          v-validate="'decimal:7|min_value:0|max_value:100000'"
                                />
                                <span class="text-danger small"
                                      v-text="errors.first('component.cseo_algae')"
                                />
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-col>
            </b-row>
        </form>

        <template #modal-footer>
            <div class="w-100">
                <b-row>
                    <b-col cols="12"
                           class="text-center"
                    >
                        <b-button @click="validateForm"
                                  variant="primary"
                                  class="mr-1"
                                  size="sm"
                        >
                            <i class="fa fa-save"></i> Guardar
                        </b-button>
                        <b-button @click="setModalToxicityShow(false)"
                                  variant="secondary"
                                  class="ml-1"
                                  size="sm"
                        >
                            <i class="fa fa-close"></i> Cancelar
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </template>

    </b-modal>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'modal',
    computed: {
        ...mapState('calculator', [
            'modal_toxicity',
            'component',
            'product',
            'action',
            'manufacturers',
            'component',
            'measure_units_cl_50'
        ])
    },
    methods: {
        ...mapActions('calculator', [
            'getManufacturers',
            'createProduct',
            'updateToxicitiesComponents',
            'getProduct'
        ]),
        ...mapMutations('calculator', [
            'setModalToxicityShow'
        ]),
        validateForm() {
            this.$validator.validateAll('component')
                .then(async (result) => {
                    if (result) {
                        await this.updateToxicitiesComponents({components: [this.component]});

                        const product_id = this.$route.params.product_id;
                        const company_id = this.$route.params.company_id;

                        if (!!product_id && !!company_id) {
                            this.setModalToxicityShow(false);
                            this.$emit('update');
                        }
                    }
                });
        }
    }
};
</script>

<style scoped>

</style>
